export function getPixelValueFromRem(remString: string) {
  const remValue = Number.parseFloat(remString);
  const result = remValue * Number.parseFloat(getComputedStyle(document.documentElement).fontSize);

  return Number(result.toFixed(2));
}
